import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@app/ui';
import pacingActions from '../../actions/pacing';
import connect from '../../utils/connect';
import PropTypes from 'prop-types';

const ApplyFilter = ({ getGoals, filter }) => {
    const { t } = useTranslation('tools');
    const onClick = async () => {
        const filters = Object.entries(filter).reduce(
            (acc, [column, { selected }]) => {
                if (Object.entries(selected).length === 0) return acc;
                const ids = Object.entries(selected)
                    .filter(([, isPresent]) => isPresent)
                    .map(([id]) => {
                        const isPlacementString =
                            id.includes('-') && !isNaN(id.charAt(0));
                        if (!isPlacementString) {
                            const [, value] = id.split('-');
                            return value ? parseInt(value) : parseInt(id);
                        } else {
                            // sending a placement string as filter, handle for single+multiple ids
                            return id.includes(',') ? id.split(',') : id;
                        }
                    });
                acc[column] = ids;
                return acc;
            },
            {},
        );
        if (filters.rightsholderPlacementIds) {
            filters.rightsholderPlacementIds =
                filters.rightsholderPlacementIds.flat();
        }
        await getGoals(filters);
    };
    return (
        <Button variant="primary" size="large" onClick={onClick}>
            {t('pacing.buttons.applyFilters')}
        </Button>
    );
};

ApplyFilter.propTypes = {
    getGoals: PropTypes.func,
    filter: PropTypes.object,
};

export default connect([], pacingActions)(ApplyFilter);
